"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _MerchandiseSelectors = require("pricing-pages-unified-ui/selectors/MerchandiseSelectors");

var _BundlePage = require("pricing-pages-unified-ui/components/bundle-page/BundlePage");

var _SuiteEditionMerchIdMap = _interopRequireDefault(require("pricing-pages-unified-ui/constants/SuiteEditionMerchIdMap"));

var _Hubs = _interopRequireDefault(require("self-service-api/constants/Hubs"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactRedux = require("react-redux");

var _HubBundleHeader = _interopRequireDefault(require("pricing-pages-unified-ui/components/bundle-page/HubBundleHeader"));

var Editions = _interopRequireWildcard(require("self-service-api/constants/Editions"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _responsiveBreakpoints = _interopRequireDefault(require("pricing-pages-unified-ui/utils/responsiveBreakpoints"));

var _PlanButton = _interopRequireDefault(require("pricing-pages-unified-ui/components/bundle-page/PlanButton"));

var _UnavailablePlanButton = _interopRequireDefault(require("pricing-pages-unified-ui/components/bundle-page/UnavailablePlanButton"));

var _publicPageUrls = require("pricing-pages-unified-ui/utils/publicPageUrls");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _colors = require("HubStyleTokens/colors");

var _MarketingContactsSelectors = require("../../selectors/MarketingContactsSelectors");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    flex-direction: column;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ButtonFlex = (0, _styledComponents.default)(_UIFlex.default).withConfig({
  displayName: "CmsHubBundle__ButtonFlex",
  componentId: "sc-1pme7jo-0"
})(["", ";"], _responsiveBreakpoints.default.phone(_templateObject()));

var ButtonWrapper = _styledComponents.default.div.withConfig({
  displayName: "CmsHubBundle__ButtonWrapper",
  componentId: "sc-1pme7jo-1"
})(["width:100%;"]);

var PlanButtonWrapper = function PlanButtonWrapper(_ref) {
  var edition = _ref.edition,
      setActiveEdition = _ref.setActiveEdition,
      planSelected = _ref.planSelected;
  var isInMCBeta = (0, _reactRedux.useSelector)(_MarketingContactsSelectors.isInMCBetaSelector);

  var merchandiseId = (0, _SuiteEditionMerchIdMap.default)(isInMCBeta)[edition][_Hubs.default.HUB_CMS];

  return _react.default.createElement(_PlanButton.default, {
    edition: edition,
    merchandiseId: merchandiseId,
    selected: planSelected === merchandiseId,
    onSelectedChange: function onSelectedChange() {
      return setActiveEdition(edition);
    }
  });
};

var CmsHubBundle = function CmsHubBundle(_ref2) {
  var title = _ref2.title,
      subtitle = _ref2.subtitle,
      products = _ref2.products;

  var _useContext = (0, _react.useContext)(_BundlePage.BundleContext),
      state = _useContext.state,
      setState = _useContext.setState;

  var cmsPlanSelected = state.cmsPlanSelected;
  var isInMCBeta = (0, _reactRedux.useSelector)(_MarketingContactsSelectors.isInMCBetaSelector);

  var setActiveEdition = function setActiveEdition(edition) {
    var newMerchId = (0, _SuiteEditionMerchIdMap.default)(isInMCBeta)[edition][_Hubs.default.HUB_CMS];

    if (cmsPlanSelected) {
      var oldProduct = products[cmsPlanSelected];

      if (oldProduct.edition === edition) {
        setState({
          cmsPlanSelected: null
        });
        return;
      }
    }

    setState({
      cmsPlanSelected: newMerchId
    });
  };

  return _react.default.createElement("div", {
    className: "m-bottom-12",
    "data-selenium-id": "cms-hub-bundle-root",
    "data-merch-id": cmsPlanSelected
  }, _react.default.createElement(_HubBundleHeader.default, {
    title: title,
    subtitle: subtitle,
    hub: _Hubs.default.HUB_CMS,
    gaClassName: (0, _publicPageUrls.getGAClassName)('bundle-pricing-cmscompare'),
    isNew: "true"
  }), _react.default.createElement(ButtonFlex, {
    className: "m-top-6"
  }, _react.default.createElement(ButtonWrapper, {
    className: "m-right-2"
  }, _react.default.createElement(_UnavailablePlanButton.default, null)), _react.default.createElement(ButtonWrapper, {
    className: "m-right-2"
  }, _react.default.createElement(PlanButtonWrapper, {
    edition: Editions.PROFESSIONAL,
    planSelected: cmsPlanSelected,
    setActiveEdition: setActiveEdition
  })), _react.default.createElement(ButtonWrapper, null, _react.default.createElement(PlanButtonWrapper, {
    edition: Editions.ENTERPRISE,
    planSelected: cmsPlanSelected,
    setActiveEdition: setActiveEdition
  }))), _react.default.createElement("div", {
    className: "m-top-2",
    style: {
      fontSize: '12px',
      color: _colors.EERIE
    }
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "bundles.cms.save25"
  })));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    products: (0, _MerchandiseSelectors.merchandiseSelector)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(CmsHubBundle);

exports.default = _default;
module.exports = exports.default;